import {HTMLAttributes, useEffect, useRef} from 'react';
import {twMerge} from '../../../common/twMerge';
import {Icon} from '../../atoms/Icon/Icon';
import {IconType} from '../../atoms/Icon/IconType.enum';

interface DialogOptionProps extends HTMLAttributes<HTMLDivElement> {
  isChecked?: boolean;
}

export function DialogOption({
  children,
  isChecked = false,
  className,
  ...props
}: DialogOptionProps) {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (ref.current && isChecked) {
      ref.current.focus();
    }
  }, [isChecked]);

  return (
    <div
      ref={ref}
      className={twMerge(
        'flex cursor-pointer items-center justify-center py-16pxr focus:outline-hidden h-56pxr',
        className
      )}
      tabIndex={0}
      {...props}
    >
      <div
        className={twMerge(
          'font-medium2 relative break-all text-center text-theme-solid-60',
          isChecked && 'font-medium2-bold text-theme-solid-100'
        )}
      >
        {children}
        {isChecked && (
          <Icon
            className="absolute top-1/2 left-full -translate-y-1/2"
            type={IconType.PopupCheck}
            height={24}
            width={24}
          />
        )}
      </div>
    </div>
  );
}

export const DialogOptionType = (<DialogOption />).type;
